import { linko } from "@shared/linko";

export interface PartnerOrganizationCoverageQueryBody {
  organizationId: string;
  dateFrom: string;
  dateTo: string;
  partnerOrganizationIds?: string[];
}

export interface PartnerOrganizationCoverageRow {
  partnerOrganizationId: string;
  name: string;
  logoImageId: string | null;
  comments: string;
  cooperationLevel: number | null;
  handledBy: "CALL_CENTER" | "COORDINATORS" | null;
  handlingManagerId: string | null;
  handlingManagerName: string | null;
  nextFollowUpAt: Date | string | null;
  lastCommunicationAt: Date | string | null;
  lastLoginAt: Date | string | null;
  lastNeedAt: Date | string | null;
  missionCount: number;
  slotCount: number;
  fullMissionCount: number;
  emptyMissionCount: number;
  fullMissionPercent: number | null;
  registrationsInRange: number;
  assignedSeats: number;
  missingSeats: number;
  fillRatePercent: number | null;
  avgVolunteersPerMission: number | null;
}

export interface PartnerOrganizationCoverageSummary {
  orgCount: number;
  missionCount: number;
  slotCount: number;
  fullMissionCount: number;
  emptyMissionCount: number;
  fullMissionPercent: number | null;
  registrationsInRange: number;
  assignedSeats: number;
  missingSeats: number;
  fillRatePercent: number | null;
  avgVolunteersPerMission: number | null;
}

export interface PartnerOrganizationCoverageResult {
  dateFrom: string;
  dateTo: string;
  openMissionsInRange: number;
  organizations: PartnerOrganizationCoverageRow[];
  summary: PartnerOrganizationCoverageSummary;
}

type StatisticsCoverageQueries = {
  getPartnerOrganizationCoverage: (
    body: PartnerOrganizationCoverageQueryBody,
  ) => Promise<{ data: PartnerOrganizationCoverageResult }>;
};

export async function fetchPartnerOrganizationCoverage(
  body: PartnerOrganizationCoverageQueryBody,
): Promise<PartnerOrganizationCoverageResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsCoverageQueries;
  const { data } = await queries.getPartnerOrganizationCoverage(body);
  return data;
}
